import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default {
    name     : "swiper-default",
    _selector: "[data-swiper]",
    _swipers : [],
    init() {
        this.initSwiper();
    },

    initSwiper()
    {
        this._swipers = document.querySelectorAll(this._selector);

        if (!this._swipers) {
            return;
        }

        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

        for (const container of this._swipers) {
            const swiper = new Swiper(container, {
                loop: true,
                spaceBetween: 30,
                slidesPerView: 1,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            });

            // 3 slides = 1 real slide
            if (swiper.slides.length === 3) {
                if (typeof container.id !== 'undefined') {
                    document.querySelector('#'+container.id+ ' .swiper-button-next').classList.add('d-none');
                    document.querySelector('#'+container.id+ ' .swiper-button-prev').classList.add('d-none');
                }
            }
        }
    }

};